<template>
  <div class="info-container">
    <div class="tabs tabs-infocard is-toggle is-centered">
      <ul style="border-bottom: none !important; background: white;">
        <li :class="{'is-active': isSeekerCard}"><a @click="isSeekerCard=true;isWatchPage=false;isDragCard=false;;isTalkSetting=false">訪問者情報</a></li>
        <li :class="{'is-active': isWatchPage}"><a @click="isSeekerCard=false;isWatchPage=true;isDragCard=false;isTalkSetting=false">見てるページ</a></li>
        <li :class="{'is-active': isDragCard}" v-if="user.permission!==2"><a @click="isSeekerCard=false;isWatchPage=false;isDragCard=true;isTalkSetting=false">アクション</a></li>
        <li :class="{'is-active': isTalkSetting}"><a @click="isSeekerCard=false;isWatchPage=false;isDragCard=false;isTalkSetting=true">トーク設定</a></li>
      </ul>
    </div>
    <div class="infocard-container disp-scroll" style="width: 100%; height: 100%;" v-if="isSeekerCard">
      <div style="width: 100%; height: 100%; padding: 0;">
        <div class="infocard" style="width: 100%;">
          <b-field horizontal label="name">
            <b-input v-model="selectroom.skname"></b-input>
          </b-field>
          <b-field horizontal label="email">
            <b-input v-model="selectroom.email"></b-input>
          </b-field>
          <hr>
          <div class="info-box">
            <p><span style="padding-left: 10px; font-weight:600; line-height: 1.5; font-size: 14px;">端末</span><span style="margin-left:127px; font-size: 13.5px;">{{computer()}}</span></p>
            <p><span style="padding-left: 10px; font-weight:600; line-height: 1.5; font-size: 14px;">ブラウザ</span><span style="margin-left:100px; font-size: 13.5px;">{{browser()}}</span></p>
            <p><span style="padding-left: 10px; font-weight:600; line-height: 1.5; font-size: 14px;">訪問回数</span><span style="margin-left:100px; font-size: 13.5px;">{{selectroom.count}} 回</span></p>
          </div>
          <hr>
          <div style="height: auto; ">
            <b-table
              class="disp-scroll"
              style="font-size: 12px; height: calc(100vh - 350px);"
              :data="makeHistoryURL()"
              :columns="columns">
            </b-table>
          </div>
          <hr>
          <b-field>
            <a class="button is-primary"
              @click="saveSeekerInfoCard()"
              style="width: 100%; text-align:center;"
              v-if="user.permission!==2"
              ><span class="mdi mdi-content-save"
                      style="margin-right: 10px; transform: scale(1.5);"></span>保存</a>
            <a class="button is-primary"
              style="width: 100%; text-align:center;"
              v-if="user.permission===2"
              disabled><span class="mdi mdi-content-save"
                      style="margin-right: 10px; transform: scale(1.5);"></span>保存</a>
          </b-field>
        </div>
      </div>
    </div>
    <div v-if="isWatchPage" class="watch-box">
      <iframe :src="selectroom.rooturl+selectroom.url[0].url" id="ndr-mgtool-iframe" frameborder=0 style="width: 960px; height: 500px; transform: scale(1.01, 1.01); transform-origin: 0 0; min-width: 500px; min-height: 690px;"></iframe>
    </div>
    <!-- メッセージ送付機能 -->
    <div class="card-container disp-scroll" style="width: 100%; height: 100%;" v-if="isDragCard&&user.permission!==2">
      <draggable v-model="user.cards" @end="saveCardsOrder(user.cards)" :options="{animation: 250, group: { name:'CHAT', pull:'clone', put:false}, filter: '.ignore-elements'}">
        <div class="card" style="overflow: hidden; padding: 10px; margin: 10px; border-radius: 5px;" v-for="(c, index) in user.cards" :key="index">
          <div style="text-align:left;">
            <p v-if="!c.editable&&c.type==='textarea'" class="edit-margin">{{alterReplace(c.text, true)}}</p>
            <button v-for="(m, indexButton) in c.text.replace('[card]', '').replace('|[/card]', '').replace('[/card]', '').split('|')"
                :key="indexButton"
                v-if="buttonCreate(m)!==''&&c.type!=='textarea'"
                class="button"
                style="margin:10px;"
                :class="{
                  'is-info': colorCreate(m) === 'Blue',
                  'is-warning': colorCreate(m) === 'Yellow',
                  'is-danger': colorCreate(m) === 'Red'
                  }">{{ buttonCreate(m) }}</button>
            <b-input type="textarea" v-model="c.text" v-if="c.editable&&selectedType[index]!=='button'" class="edit-margin"></b-input>
            <span v-for="n in 5" :key="n">
              <b-field v-if="c.editable&&selectedType[index]==='button'">
                <b-input v-model="buttonMD[n]" v-if="n <= selectedNum[index]" class="edit-margin" style="margin-left: 0"></b-input>
                <b-select placeholder="色を選択" v-model="buttonCL[n]" v-if="n <= selectedNum[index]" class="edit-margin" style="margin-left: 0">
                  <option v-for="(color, colorNum) in buttonColors" :key="colorNum">
                    {{color}}
                  </option>
                </b-select>
              </b-field>
            </span>
            <b-field>
              <b-select placeholder="タイプを選択" v-if="c.editable" v-model="selectedType[index]" class="edit-margin" @input="changeSelect(index)">
                  <option :value="text">
                    Text
                  </option>
                  <option :value="button">
                    Button
                  </option>
              </b-select>
              <b-select placeholder="数を選択" v-if="c.editable&&selectedType[index]==='button'" v-model="selectedNum[index]" class="edit-margin" style="margin-left: 0">
                  <option v-for="i in 5" :key="i" class="edit-margin">
                    {{i}}
                  </option>
              </b-select>
            </b-field>
            <span style="font-size:8px; color:gray; position: absolute; bottom: 5px; right: 60px;" v-if="isEditDisplay==index">他のカードを編集中です。</span>
            <a style="position: absolute; bottom: 0; right: 30px; height: 30px; width: 30px;"
               @click="saveButtonCard(c.id, c.type, c.text, index)"
               v-if="c.editable">
              <span class="mdi mdi-content-save mdi-24px"></span>
            </a>
            <a style="position: absolute; bottom: 0; right: 30px; height: 30px; width: 30px;"
               @click="editCard(index)"
               v-if="!c.editable && isEdit==-1">
               <span class="mdi mdi-playlist-edit mdi-24px"></span>
            </a>
            <a style="position: absolute; bottom: 0; right: 30px; height: 30px; width: 30px; color:gray;"
               v-if="!c.editable && isEdit!=-1"
               @mouseover="editOver(index)"
               @mouseleave="editLeave()">
               <span class="mdi mdi-playlist-edit mdi-24px"></span>
            </a>
             <a style="position: absolute; bottom: 0; right: 0; height: 30px; width: 30px;"
               v-if="isEdit==-1"
               @click="isEdit=-1; $store.dispatch('auth/deleteCard', {id: c.id, type: c.type, text: c.text, isDelete: true, index: index})">
              <span class="mdi mdi-delete mdi-24px"></span>
            </a>
            <a style="position: absolute; bottom: 0; right: 0; height: 30px; width: 30px;"
               v-else-if="isEdit==index"
               @click="isEdit=-1; $store.dispatch('auth/deleteCard', {id: c.id, type: c.type, text: c.text, isDelete: true, index: index})">
              <span class="mdi mdi-delete mdi-24px"></span>
            </a>
            <a style="position: absolute; bottom: 0; right: 0; height: 30px; width: 30px; color:gray;"
               v-else
               @mouseover="editOver(index)"
               @mouseleave="editLeave()">
              <span class="mdi mdi-delete mdi-24px"></span>
            </a>
          </div>
        </div>
        <div class="card" style="padding: 10px; margin: 10px; border-radius: 5px;" @click="$store.dispatch('auth/addCard', {type: 'textarea', text: 'Empty'})">
          <a style="height: 100%; width: 100%;"><span class="mdi mdi-plus mdi-24px"></span></a>
        </div>
      </draggable>
    </div>
    <div v-if="isTalkSetting" class="info-setting">
      <div class="list-setting">
          <a class="button"
             style="width: 100%; height: auto; text-align:left;"
             :download="download" id="download" @click="downloadMessage()">
               <p><span class="mdi mdi-cloud-download"
                     style="margin-right: 10px; transform: scale(1.5);"></span>
                      トーク履歴をバックアップ
                  <br><span style="color: grey; font-size: 13px;">トーク内容をCSV形式で保存することができます</span></p>
          </a>
          <a class="button" :class="{'on-off': selectroom.isOmit}"
             style="width: 100%; height: auto; text-align:center;" @click="updateOmit()">
               <p><span class="mdi mdi-account-off"
                     style="margin-right: 10px; transform: scale(1.5);"></span>
                      ダッシュボードから除外（現在の状態：{{showIsOmit(selectroom.isOmit)}}）
                  <br><span style="color: grey; font-size: 13px;">ダッシュボードの各種カウントから除外できます。</span></p>
          </a>
      </div>
      <!-- <b-field v-if="user.permission===0">
        <label class="button is-primary"
           style="width: 100%; text-align:center;"
           :download="download" id="import">
             <span class="mdi mdi-cloud-upload"
                   style="margin-right: 10px; transform: scale(1.5);">
             </span>
             <input type="file" @change="selectedFile" name="file" id="file" style="display: none;">
             会話をアップロードする
        </label>
      </b-field> -->
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { mapState } from 'vuex'
import alterReplace from '@/functions/alterStrReplace'
import parseUserAgent from '@/functions/parseUserAgent'
export default {
  name: 'InfoCard',
  componentName: 'InfoCard',
  components: {
    draggable,
    alterReplace
  },
  computed: {
    ...mapState('directtalk', ['chatLogs', 'data', 'selectroom']),
    ...mapState('auth', ['user'])
  },
  data () {
    return {
      download: 'chatlogs.csv',
      isSeekerCard: true,
      isWatchPage: false,
      isDragCard: false,
      isTalkSetting: false,
      isEdit: -1,
      isEditDisplay: -1,
      defaultSortDirection: 'desc',
      button: 'button',
      text: 'text',
      selectedType: [],
      selectedNum: [],
      buttonMD: [],
      buttonCL: [],
      buttonColors: [
        'White',
        'Blue',
        'Yellow',
        'Red'
      ],
      columns: [
        {
          field: 'sessionTime',
          label: '秒',
          width: '50'
        },
        {
          field: 'createdAt',
          label: '日時',
          width: '120'
        },
        {
          field: 'url',
          label: 'URL'
        }
      ]
    }
  },
  methods: {
    makeHistoryURL () {
      var historyURL = []
      for (var i in this.selectroom.url) {
        const time1 = new Date(this.selectroom.url[i].createdAt.replace(/-/g, '/').substring(0, 17) + this.selectroom.url[i].createdAt.substring(25, 29))
        const time2 = new Date(this.selectroom.url[i].createdAt)
        let time = time1
        if (isNaN(time1)) {
          time = time2
        }
        var temp = {'createdAt': ' ', 'url': ' '}
        temp.sessionTime = this.selectroom.url[i].sessionTime
        temp.createdAt = time.getMonth() + 1 + '/' + time.getDate() + ' ' + time.getHours() + ':' + ('00' + time.getMinutes()).slice(-2) + ' ' + ('00' + time.getSeconds()).slice(-2)
        temp.url = this.selectroom.url[i].url
        historyURL.push(temp)
      }
      console.debug('historyURL: ' + historyURL)
      return historyURL
    },
    computer () {
      console.log('USERAGENT: ' + JSON.stringify(this.selectroom))
      return parseUserAgent.device(this.selectroom.useragent)
    },
    browser () {
      console.log('USERAGENT: ' + JSON.stringify(this.selectroom))
      return parseUserAgent.browser(this.selectroom.useragent)
    },
    updateOmit () {
      this.selectroom.isOmit = !this.selectroom.isOmit
      this.$store.dispatch('directtalk/updateOmit', this.selectroom.isOmit)
    },
    saveSeekerInfoCard () {
      this.$store.dispatch('directtalk/saveSeekerInfoCard')
        .then(() => this.$buefy.toast.open({
          message: '保存しました。',
          type: 'is-success'
        }))
        .catch(() => this.$buefy.toast.open({
          message: '保存中にエラーが起きました。',
          type: 'is-danger'
        }))
    },
    saveButtonCard (id, type, text, index) {
      console.debug('id: ' + JSON.stringify(id))
      console.debug('type: ' + JSON.stringify(type))
      console.debug('text: ' + JSON.stringify(text))
      console.debug('index: ' + JSON.stringify(index))
      this.isEdit = -1
      if (this.selectedType[index] === 'button' && this.selectedNum[index] != null) {
        console.info('Type is button')
        text = '[card]'
        type = 'button'
        for (var i = 1; i <= this.selectedNum[index]; i++) {
          text += '[button]' + alterReplace(this.buttonMD[i], false) + ',' + this.buttonCL[i] + '[/button]|'
        }
        text += '[/card]'
      } else {
        if (text == '') {
          alert('内容を入力してください。')
          text = 'Empty'
        }
        type = 'textarea'
        text = alterReplace(text, false)
      }
      this.buttonMD = []
      this.buttonCL = []
      console.log('*** COLOR: ' + text)
      this.$store.dispatch('auth/setCard', {id: id, type: type, text: text, index: index})
    },
    buttonCreate (m) {
      console.debug('m: ' + JSON.stringify(m))
      var text = m.replace('[button]', '').replace('[/button]', '')
      console.debug('text: ' + text)
      return alterReplace(text.split(',')[0], true)
    },
    colorCreate (m) {
      console.debug('m: ' + JSON.stringify(m))
      var text = m.replace('[button]', '').replace('[/button]', '')
      console.debug('text: ' + text)
      return text.split(',')[1]
    },
    editCard (idx) {
      console.debug('idx: ' + JSON.stringify(idx))
      this.isEdit = idx
      if (this.user.cards[idx].text.indexOf('[button]') !== -1) {
        console.info('Type is button')
        this.selectedType[idx] = 'button'
        var buttonSpl = this.user.cards[idx].text.replace('[card]', '').replace('|[/card]', '').replace('[/card]', '').split('|')
        this.selectedNum[idx] = buttonSpl.length
        this.buttonMD.push(null)
        this.buttonCL.push(null)
        for (const i in buttonSpl) {
          this.buttonMD.push(this.buttonCreate(buttonSpl[i]))
          this.buttonCL.push(this.colorCreate(buttonSpl[i]))
        }
      } else {
        console.info('Type is text')
        this.selectedType[idx] = 'text'
        this.user.cards[idx].text = alterReplace(this.user.cards[idx].text, true)
      }
      this.$store.dispatch('auth/editCard', idx)
    },
    saveCardsOrder (cards) {
      console.debug('cards: ' + JSON.stringify(cards))
      for (var c in cards) {
        cards[c].order_num = Number(c) + 1
      }
      this.$store.dispatch('auth/setCardsOrder', cards)
    },
    messageTime (time) {
      return time.getFullYear() + '/' + ('00' + (time.getMonth() + 1)).slice(-2) + '/' + time.getDate() + ' ' + time.getHours() + ':' + ('00' + time.getMinutes()).slice(-2)
    },
    messageTimeTZ (time) {
      console.debug('time: ' + JSON.stringify(time))
      return time.getFullYear() + '-' + ('00' + (time.getMonth() + 1)).slice(-2) + '-' + time.getDate() + ' ' + ('00' + time.getHours()).slice(-2) + ':' + ('00' + time.getMinutes()).slice(-2) + ':' + ('00' + time.getSeconds()).slice(-2) + '.000000+0000'
    },
    makeCSV (text) {
      console.debug('text: ' + JSON.stringify(text))
      var csv = ''
      var title = '名前, メッセージ, 日時, 既読/未読, import用データ1, import用データ2, import用データ3'
      var newLine = '\n'
      var comma = ', '
      csv += title + newLine
      for (var i in text) {
        csv += text[i].name.replace(/,/g, ';').replace(/\n/g, ' ') + comma
        // csv += text[i].message.split(',').join(';').split('\n').join(' ') + comma
        csv += alterReplace(text[i].message, true).replace(/,/g, ';').replace(/\n/g, ' ') + comma
        csv += this.messageTime(text[i].createdAt) + comma
        if (text[i].speaker === 'my') {
          csv += '自分' + comma
        } else if (new Date(this.selectroom.readTime) > text[i].createdAt) {
          csv += '既読' + comma
        } else {
          csv += '未読' + comma
        }
        csv += text[i].speaker + comma
        csv += this.selectroom.name + comma
        csv += this.messageTimeTZ(text[i].createdAt) + newLine
      }
      console.debug('csv: ' + csv)
      return csv
    },
    downloadMessage () {
      // excelで開くためにBOMを付与
      var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      var content = this.makeCSV(this.chatLogs)
      var blob = new Blob([bom, content], {'type': 'text/csv'})
      if (window.navigator.msSaveBlob) {
        console.info('window.navigator.msSaveBlob is true')
        window.navigator.msSaveBlob(blob, this.download)
        window.navigator.msSaveOrOpenBlob(blob, this.download)
      } else {
        console.info('window.navigator.msSaveBlob is false')
        document.getElementById('download').href = window.URL.createObjectURL(blob)
      }
    },
    selectedFile (e) {
      console.error('e: ' + JSON.stringify(e))
      e.preventDefault()
      let files = e.target.files
      var reader = new FileReader()
      reader.readAsText(files[0])
      var vm = this
      reader.onload = function (e) {
        console.log('**********************')
        console.log(reader.result)
        console.log('**********************')
        vm.$store.dispatch('directtalk/importMessage', {data: reader.result})
      }
    },
    showIsOmit (flg) {
      console.debug('flg: ' + JSON.stringify(flg))
      if (flg) return 'ON'
      else return 'OFF'
    },
    alterReplace (m, d) {
      return alterReplace(m, d)
    },
    changeSelect (idx) {
      this.user.cards[idx].text = 'Empty'
    },
    editOver (idx) {
      this.isEditDisplay = idx
    },
    editLeave () {
      this.isEditDisplay = -1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-container {
  height: 100%;
  width: 100%;
  background :#f2f2f0;
  border-left: solid thin #ccc;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
hr {
  margin: 0.5rem 0;
}
.infocard {
  height: 100%;
  padding: 10px;
  text-align: left;
  border-top: solid thin #ccc;
}
.info-setting {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.list-setting {
  height: 100%;
}
.tabs-infocard {
  min-height: 50px;
  max-height: 50px;
  padding: 7px;
  font-size: 12px !important;
  margin-bottom: -2px;
}
.watch-box {
  width: 100%;
  height: 100%;
  padding: 10px;
}
.edit-margin {
  margin: 10px;
}

@media screen and (max-width: 1150px) {
  .tabs-infocard{
    font-size: 12px !important;
  }
}

@media screen and (max-width: 1100px) {
  .tabs-infocard{
    font-size: 12px !important;
  }
}

@media screen and (max-width: 1024px) {
  .tabs-infocard{
    font-size: 12px !important;
  }
}

.tabs {
  white-space: normal !important;
}

.on-off {
  background: #F0F0F0;
}

#ndr-mgtool-iframe {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DirectTalk/InfoCard.vue